<template>
<v-dialog v-model="dialog" max-width="460">
    <v-card flat>
        <v-card-text class="pa-4">
            <slot name="text-confirmation">
                {{ $t('dialog_confirmation.standard_text') }}
            </slot>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <slot name="actions">
                <v-btn dark color="red" :loading="loading" @click="emitDelete()">
                    {{ $t('button.delete') }}
                </v-btn>
                <v-btn color="primary" text @click="emitCancel()">
                    {{ $t('button.cancel') }}
                </v-btn>
            </slot>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    name: "IMDialogConfirmation",
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        emitDelete() {
            this.$emit('delete');
        },
        emitCancel() {
            this.$emit('cancel');
        },
    }
}
</script>
